import { render, staticRenderFns } from "./hs-verification-app.vue?vue&type=template&id=45749ae2&scoped=true&"
import script from "./hs-verification-app.vue?vue&type=script&lang=js&"
export * from "./hs-verification-app.vue?vue&type=script&lang=js&"
import style0 from "./hs-verification-app.vue?vue&type=style&index=0&id=45749ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45749ae2",
  null
  
)

export default component.exports